<template>
    <div class="auth">
          <ul class="tabs">
            <li :class="{active : login}" @click="login = true ;signup = false ">Sign Up</li>
            <li :class="{active : signup}" @click="signup = true ;login = false">Login</li>
        </ul>
         <div class='' v-if="login">
            <ul class="form">
                <li>
                    <input type="email" class="form-input" placeholder="Email" v-model="email" />
                </li>
                <li>
                    <input type="password" class="form-input" placeholder="Password" v-model="password"/>
                </li>
                <li>
                    <input type="password" class="form-input" placeholder="Reenter Password" v-model="pass2"/>
                </li>
            <li class="uk-text-right">
            <button type="primary" class="btn-submit" @click="signUp">Sign Up</button>
            </li> 
            </ul>
        </div>
         <div class="" v-else>
            <ul class="form">
                <li>
                    <input type="email" class="form-input" placeholder="Email" v-model="email" autofocus/>
                </li>
                <li>
                    <input type="password" class="form-input" placeholder="Password" v-model="password" />
                </li>
            <li class="uk-text-right">
            <button type="primary" class="btn-submit" @click="signIn">Login</button>
            </li> 
            </ul>
        </div>
    </div>

</template>
<script type="text/javascript">
    import { Auth, firestore } from '../main'
    export default {
        name: 'auth',
        data() {
            return {
                login: true,
                signup: false,
                email: '',
                password: '',
                pass2: '',
                show: true,
            }
        },
        methods: {
            signUp: function() {
                if (this.password == this.pass2) {
                    Auth.createUserWithEmailAndPassword(this.email, this.password).then(
                        (user) => {
                            this.addUser(user.user, 'signup')
                            this.email = ''
                            this.password = ''
                            this.pass2 = ''
                            this.$router.push({ path: '/download' })
                        },
                        (err) => {
                            alert('Oops. ' + err.message)
                        }
                    );
                }
                else {
                    alert("password doesn't match")
                }
            },
            signIn: function() {
                Auth.signInWithEmailAndPassword(this.email, this.password).then(
                    (user) => {
                        this.addUser(user.user, "signin")
                        this.email = ''
                        this.password = ''
                        this.user = user.user;
                        // alert('thanks for the signup currently the product has a bug which I am trtrying to solve will update you once its resolved ,THANKS')
                        this.$router.push({ path: '/download' })
                    },
                    (err) => {
                        alert('Oops. ' + err.message)
                    }
                );
            },
            addUser: function(user, method) {
                switch (method) {
                    case 'signup':
                        var user = {
                            FirstName: user.displayName,
                            LastName: '',
                            email: this.email,
                            Sync: true,
                            isActive: false,
                            payment: false,
                            uid: user.uid,
                            timestamp: new Date()
                        }
                        firestore.doc('users/' + user.uid).set({
                            FirstName: user.FirstName,
                            LastName: user.LastName,
                            Sync: user.Sync,
                            isActive: user.isActive,
                            email: this.email,
                            payment: user.payment,
                            uid: user.uid,
                            timestamp: new Date()
                        })
                        firestore.doc('users/' + user.uid).collection('snippets').add({
                            Title: 'sample snippet',
                            code: `// https://github.com/michael-ciniawsky/postcss-load-config
                                module.exports = {
                                  "plugins": {
                                    // to edit target browsers: use "browserlist" field in package.json
                                    "autoprefixer": {}
                                  }
                                }
                                `,
                            id:0,
                            isDeleted:false,
                            selectedLang:'javaScript',
                            selectedTags:[
                                "Front End",
                                "Backend",
                                "ios",
                                'Android',
                            ],
                            timestamp:new Date()
                        })
                        firestore.doc('users/'+user.uid).collection('ExistingTags').add({
                            tags:[
                                "Front End",
                                "Backend",
                                "ios",
                                'Android',
                            ],
                          
                        })
                        break
                    case 'signin':
                        firestore.doc('users/' + user.uid).update({
                            timestamp: new Date()
                        })
                        break
                }

            },
            signout: function() {
                Auth.signOut().then(function() {
                    // Sign-out successful.
                }).catch(function(error) {
                    // An error happened.
                });
            }
        },
    }
</script>
<style type="text/css">
</style>



// WEBPACK FOOTER //
// src/components/Auth.vue